__turbopack_context__.v({
  "postalEntryContainer": "PostalEntry-module__YVf4wW__postalEntryContainer",
});
